const stateRights: any = {
  andhrapradesh: require("./editRights/andhrapradesh.json"),
  bihar: require("./editRights/bihar.json"),
  maharashtra: require("./editRights/maharashtra.json"),
  madhyapradesh: require("./editRights/madhyapradesh.json"),
  karnataka: require("./editRights/karnataka.json"),
  uttarpradesh: require("./editRights/uttarpradesh.json"),
  assam: require("./editRights/assam.json"),
  gujarat: require("./editRights/gujarat.json"),
  odisha: require("./editRights/odisha.json"),
  rajasthan: require("./editRights/rajasthan.json"),
  uttarakhand: require("./editRights/uttarakhand.json")
};

export { stateRights };
